import { Routes } from '@/routes';

export default {
	'guides-and-tours.index': () => import('@/modules/guides-and-tours/index'),
} as Routes;
